import {Component, inject} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {ActivatedRoute} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {KENDO_INPUTS} from '@progress/kendo-angular-inputs';
import {NgClass} from '@angular/common';

import {ValAppSettingsService} from '../../../../val-ammon-services/val-app-settings-lib/src/public-api';
import {parametresClient, RetournerCheminsApplication, VAL_MODE_ROUTEUR, ValNavigationService} from '../../../../val-definitions-communes-lib/src/public-api';
import {authentificationConfiguration} from '../../public-api';

//Page de saisie des paramètres de connexion
@Component (
{
  selector: 'val-page-saisie-parametres-connexion',
  imports: 
  [
    FormsModule,
    NgClass,
    KENDO_INPUTS
  ],
  templateUrl: './page-saisie-parametres-connexion.component.html',
  styleUrl: './page-saisie-parametres-connexion.component.scss',
})
export class PageSaisieParametresConnexionComponent 
{
  //Création
  //  Paramètres
  //    oAuthService       : Service d’authentification
  //    appSettingsService : Service d’accès à la configuration de l’application
  //    routeActive        : Route active
  constructor (private oAuthService: OAuthService, private appSettingsService: ValAppSettingsService, private routeActive: ActivatedRoute) 
  {
    this.erreur = false;

    this.codeClient = this.routeActive.snapshot.queryParamMap.get ("codeClient") ?? "";

    if (!this.codeClient)
      this.codeClient = sessionStorage.getItem ("code_client") || "";

    this.sso = this.routeActive.snapshot.queryParamMap.get ("sso") ?? "";

    if (this.codeClient)
    {
      sessionStorage.setItem ("code_client", this.codeClient);

      this.InitialiserAuthentificationConfiguration ();

      this.Connexion ();
    }
    else
      this.codeClient = localStorage.getItem ("code_client_utilisateur") ?? "";
  }

  //Code client
  public codeClient: string;

  //SSO
  public sso: string;

  //Indique si erreur du code client
  public erreur: boolean;

  //Page d’accueil, une fois connecté
  private cheminAccueil: string = RetournerCheminsApplication ().accueil;

  //Service de navigation
  private navigationService = inject (ValNavigationService);

  //Indique si chaque page a sa propre URL (mode routeur)
  private modeRouteur = inject (VAL_MODE_ROUTEUR);

  //Evénement sur le relachement d’une touche du clavier
  //  Paramètres
  //    evenement : Données de l’événement
  public async KeyUp (evenement: KeyboardEvent) : Promise<void> 
  {
    if (evenement.key === "Enter")
      await this.Connexion ();
  }

  //Lance la connexion
  public async Connexion () : Promise<void> 
  {
    if (this.codeClient)
    {
      sessionStorage.setItem ("code_client", this.codeClient);

      this.InitialiserAuthentificationConfiguration ();

      try
      {
        await this.oAuthService.loadDiscoveryDocumentAndTryLogin ();

        const paramsIdp = this.sso === "support" ? { kc_idp_hint: "support" } : {};

        if (!this.oAuthService.hasValidAccessToken ())
          this.oAuthService.initLoginFlow ("", paramsIdp);
        else
          //En mode routeur, la page demandée avant la connexion (sinon l’accueil) remplace /login dans l’historique ;
          //sinon, l’accueil est affiché et l’entrée de la saisie est conservée
          void this.navigationService.Naviguer (this.modeRouteur ? sessionStorage.getItem ("route_cible") || this.cheminAccueil : this.cheminAccueil, this.modeRouteur);

        localStorage.setItem ("code_client_utilisateur", this.codeClient);
      }
      catch
      {
        this.erreur = true;
      }
    }
  }

  //Initialise l’authentification
  private InitialiserAuthentificationConfiguration () : void 
  {
    let issuer: string;

    parametresClient.code = this.codeClient;

    issuer = this.appSettingsService.Configuration.OpenIdConnect.Authority;
    issuer += "/realms/" + this.codeClient;

    authentificationConfiguration.issuer = issuer;
    authentificationConfiguration.clientId = "ammon-plateforme-ui";

    this.oAuthService.configure (authentificationConfiguration);
    this.oAuthService.setupAutomaticSilentRefresh ();
  }
}
